import * as React from "react";
import { TinTuc, TinTucNew } from "../../models";
import TinTucService from "../../services/tinTuc";
import { DANH_MUC } from "../../const/danh-muc";
import { NEWS } from "../../const/seo-url";
import Image from "../../components/share/Image";
import Link from "next/link";
import { loadImage } from "../../util/image";
import { DanhMucUtil } from "../../util/danhmuc";
import { formatUrlSeo } from "../../util/seo-url";

export interface State {
  tinTuyenSinh: TinTucNew[];
}

class TinTuyenSinh extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      tinTuyenSinh: [],
      loading: false,
      bigNews: [],
      rightNews: [],
      bottomNews: [],
    };
  }

  componentDidMount() {
    TinTucService.getsNewsByDanhMucID(DANH_MUC.TUYEN_SINH, 9, 1).then((result) => {
      let tin_tuc = result.tin_tuc;
      if (result && result['tin_tuc'] && result['tin_tuc'].length > 0) {
        result['tin_tuc'].forEach(x => {
          x['url_seo_tin'] = formatUrlSeo(x['url'], x['tin_tuc_id'])
          x['url_seo_danh_muc'] = formatUrlSeo(
            x['ten_danh_muc'],
            x['danh_muc_tin_id']
          )
        })
      }
      if (result.tin_tuc) {
        if (result.tin_tuc.length > 0) {
          this.setState({
            tinTuyenSinh: result.tin_tuc,
            bigNews: tin_tuc.splice(0, 1),
            bottomNews: tin_tuc.splice(0, 4),
            rightNews: tin_tuc.splice(0, 4),
            loading: true,
          });
        }
      }
    });
  }

  bigLeftContent() {
    if (this.state.bigNews.length > 0) {
      var tinBig = this.state.bigNews[0];
      return (
        <div>
          {tinBig == null ? (
            <div>Loading...</div>
          ) : (
            <div>
              <div className="image-news-home">
                <a
                  href={`/${NEWS.TIN_TUYEN_SINH}/${tinBig.url_seo_tin}`}
                  className="link-img"
                >
                  <div className="text-bold pb-2">
                        <a href={`/${NEWS.TIN_TUYEN_SINH}`} className="btn btn-primary" style={{backgroundColor:"#0071BB", borderColor:"#0071BB"}}>ADMISSIONS</a>
                        <b className="btn text-red text-bold" style={{ whiteSpace: "initial", display: "initial", fontSize: "15px" }}>{tinBig.tieu_de}</b>
                      </div>
                  <img
                    className="img-responsive"
                    alt={tinBig.tieu_de}
                    src={loadImage(tinBig.hinh_goc)}
                  />
                </a>
              </div>
              <p className="des_news">{tinBig.mo_ta}</p>
            </div>
          )}
        </div>
      );
    } else {
      <div>Loading...</div>;
    }
  }
  smallBottomContent() {
    if (this.state.bottomNews.length > 0) {
      return (
        this.state.bottomNews.map((tinTuc) => (
          <a
            href={`/${NEWS.TIN_TUYEN_SINH}/${tinTuc.url_seo_tin}`}
            className="col-sm-3 link-img title " 
          >
            <div className="img">
              <Image
                src={loadImage(tinTuc.hinh_goc)}
                alt=""
                className="img-responsive"
                classPlaceHolder="lazy-image-list"
              />
            </div>
            {tinTuc.tieu_de}
          </a>
        ))
      );
    } else {
      return <div></div>;
    }
  }
  rightContent() {
    if (this.state.rightNews.length > 0) {
      return (
        <div className="right-tuyen-sinh">
          <div className="content-right-tuyen-sinh back-gray">
            {this.state.rightNews.map((tinTuc, index) => (
              <div>
                {index == 0 ? (
                  <span>
                    <a
                      href={`/${NEWS.TIN_TUYEN_SINH}/${tinTuc.url_seo_tin}`}
                      className=" link-img title "
                    >
                      
                      <Image
                        src={loadImage(tinTuc.hinh_goc)}
                        alt=""
                        className="img-responsive"
                        classPlaceHolder="lazy-image-list"
                      />
                    </a>
                    <a
                      href={`/${NEWS.TIN_TUYEN_SINH}/${tinTuc.url_seo_tin}`}
                      className="title text-bold wow slideInUp animated animated"
                      style={{
                        visibility: "visible",
                        animationName: "slideInUp"
                      }}
                     
                    >
                      {tinTuc.tieu_de}
                    </a>
                  </span>
                ) : (
                  <span>
                    <a
                      href={`/${NEWS.TIN_TUYEN_SINH}/${tinTuc.url_seo_tin}`}
                      className="title text-bold wow slideInUp animated animated"
                      style={{
                        visibility: "visible",
                        animationName: "slideInUp"
                      }}
                    >
                      {tinTuc.tieu_de}
                    </a>
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
  buildItemViewAll() {
    return (
      <div className="col-sm-12 text-right padding">
        <Link href="/news-admissions" legacyBehavior>
          <a className="more text-orange">
            See all &gt;&gt;
          </a>
        </Link>
      </div>
    );
  }
  render() {
    return (
      <React.Fragment>
        <div className="block back-hoatdongvuihoc">
          <div className="content-block height-block">
            <div className="row" style={{ margin: "0" }}>
              <div className="col-md-8 news-block-left">
                {this.bigLeftContent()}
              </div>
              <div className="col-md-4 news-block-right">
                {this.rightContent()}
              </div>
            </div>
            <div className="row news-block-bottom" style={{ margin: "0" }}>
              {this.smallBottomContent()}
            </div>
            {this.buildItemViewAll()}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TinTuyenSinh;
